import { GridCustomCellProps } from "@progress/kendo-react-grid";
import { CLASSNAME } from "utils/constant";
import { formatNorwegianNumber } from "utils/helper";

export const GroupFooterCell = (
    props: GridCustomCellProps,
    field: string,
    unit?: string,
    minDecimal: number = 0,
    maxDecimal: number = 0
) => {
    const sum = props.dataItem?.aggregates?.[field]?.sum;

    if (props.field === field && sum != null) {
        return (
            <td
                {...props.tdProps}
                className={`${props.className} ${CLASSNAME.TableNumeric} no-border td-bold`}
            >
                {`${formatNorwegianNumber(sum, minDecimal, maxDecimal)}${unit ? ` ${unit}` : ""}`}
            </td>
        );
    }

    return <td {...props.tdProps} />;
};